import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { lang } from "src/language/Strings";
import { routes } from "src/routes";
import { featureType } from "src/types/Feature";
type TranslatedFeature = {
  name: string;
  icon: string;
  path?: string;
};

export default function useTranslatedFeature(feature: featureType) {
  const { companyId } = useParams();
  const translate = useMemo<TranslatedFeature>(() => {
    switch (feature.name) {
      case "SigningSession":
        return {
          name: lang.signingSession,
          icon: "fa-solid fa-file-pen",
          path: feature.path?.replace(":companyId", companyId!),
        };
      case "inspection":
      case "Inspection":
        return {
          name: lang.Egenkontroller,
          icon: "fa-solid fa-check-circle",
          path: `/${companyId}/inspection`,
        };
      case "deviation":
      case "Deviation":
        return {
          name: lang.deviations,
          icon: "fa-solid fa-search",
          path: `/${companyId}/deviation`,
        };
      case "documentintelligence":
        return {
          name: lang.documentIntelligence,
          icon: "fa-solid fa-file-pen",
        };
      case "resistograph":
        return { name: lang.resistograph, icon: "fa-solid fa-chart-line" };
      case "equipment":
        return { name: lang.equipment, icon: "fa-solid fa-car" };
      case "Egenkontroller":
        return {
          name: lang.egenkontrollerTitle,
          icon: "fa-solid fa-check-circle",
          path: `/${companyId}/inspection`,
        };
      case "VehicleInspection":
        return {
          name: lang.vehicleInspection,
          icon: "fa-solid fa-car-side",
          path: `/${companyId}/vehicle-inspection/active-schemas`,
        };
      case "home":
      case "StartPage":
        return {
          name: lang.home,
          icon: "fa-solid fa-home",
          path: routes.Start.url(companyId!),
        };
      default:
        return { name: feature.name, icon: "fa-solid fa-question-circle" };
    }
  }, [companyId]);
  return translate;
}
